import React, { useEffect, useState } from 'react'
import { listAudit } from 'api/audit'
import { TextField } from 'components/ui/TextField'
import { Button } from 'components/ui/Button'

export default function AuditLogPage() {
  const [rows, setRows] = useState([])
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(true)

  const [q, setQ] = useState('')
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')
  const [page, setPage] = useState(1)
  const pageSize = 50

  const fetchRows = async () => {
    setLoading(true)
    try {
      const offset = (page - 1) * pageSize
      const { rows, count } = await listAudit({ q, dateFrom, dateTo, limit: pageSize, offset })
      setRows(rows); setCount(count)
    } finally { setLoading(false) }
  }

  useEffect(() => { fetchRows() }, [])        // init
  useEffect(() => { fetchRows() }, [page])    // page changes

  const applyFilters = () => { setPage(1); fetchRows() }
  const reset = () => { setQ(''); setDateFrom(''); setDateTo(''); setPage(1); fetchRows() }

  const totalPages = Math.max(1, Math.ceil((count || 0) / pageSize))

  return (
    <div className="space-y-4">
      <div className="grid md:grid-cols-4 gap-3">
        <TextField label="Поиск (entity/action/user_id)" value={q} onChange={e=>setQ(e.target.value)} />
        <div>
          <label className="block text-sm mb-1">Дата от</label>
          <input type="date" className="w-full rounded-lg border px-3 py-2 bg-white/90 dark:bg-slate-900"
                 value={dateFrom ? dateFrom.substring(0,10) : ''}
                 onChange={e=>setDateFrom(e.target.value ? new Date(e.target.value).toISOString() : '')} />
        </div>
        <div>
          <label className="block text-sm mb-1">Дата до</label>
          <input type="date" className="w-full rounded-lg border px-3 py-2 bg-white/90 dark:bg-slate-900"
                 value={dateTo ? dateTo.substring(0,10) : ''}
                 onChange={e=>setDateTo(e.target.value ? new Date(e.target.value).toISOString() : '')} />
        </div>
        <div className="flex items-end gap-2">
          <Button variant="outline" onClick={applyFilters}>Применить</Button>
          <Button variant="ghost" onClick={reset}>Сбросить</Button>
        </div>
      </div>

      {loading ? <div className="p-6">Загрузка…</div> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left opacity-70">
                <th className="py-2 px-2">Дата</th>
                <th className="px-2">Entity</th>
                <th className="px-2">ID</th>
                <th className="px-2">Action</th>
                <th className="px-2">User</th>
                <th className="px-2">Payload</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id} className="border-t align-top">
                  <td className="py-2 px-2 whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</td>
                  <td className="px-2">{r.entity}</td>
                  <td className="px-2">{r.entity_id}</td>
                  <td className="px-2">{r.action}</td>
                  <td className="px-2 text-xs break-all">{r.user_id || '—'}</td>
                  <td className="px-2 text-xs">
                    <pre className="max-w-[520px] overflow-auto whitespace-pre-wrap break-words">
                      {JSON.stringify(r.payload_json, null, 2)}
                    </pre>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="flex items-center justify-between text-sm pt-2">
        <div>Всего: {count}</div>
        <div className="flex items-center gap-2">
          <Button variant="outline" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page <= 1}>Назад</Button>
          <span>{page} / {totalPages}</span>
          <Button variant="outline" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page >= totalPages}>Вперёд</Button>
        </div>
      </div>
    </div>
  )
}
